
// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('SocialProviderButton')

function SocialProviderButton(props) {
  return tag('a', {
    className: classNames(
      props.className,
      bem.block(props.providerId)
    ),
    'data-provider': props.providerId,
    tabIndex: '0',
    onClick: props.onClick
  },
    tag(Icon, {
      className: bem.element('icon', props.providerId),
      id: props.providerId
    }),
    tag('label', {
      className: bem.element('label')
    },
      props.providerName
    )
  )
}

SocialProviderButton.propTypes = {
  // Values
  className: PropTypes.string,
  providerId: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = SocialProviderButton
